import { Grid } from '@mui/material'
import './CallAnalysisGlobal.css'
import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import ChatbotFAQs from '../../Component/ChatbotFAQs/ChatbotFAQs'
import LandingFooter from '../../Component/Footer/LandingFooter'
import HeroSectionNewDesign from '../../Component/HeroSectionNewDesign/HeroSectionNewDesign'
import CallAnalysisCommonComponent from '../../Component/CallAnalysisCommonComponent/CallAnalysisCommonComponent'
import ca_1 from "../../assests/Pages/CallAnalysis/ca_img_1.png";
import ca_2 from "../../assests/Pages/CallAnalysis/ca_img_2.png";
import ca_3 from "../../assests/Pages/CallAnalysis/ca_img_3.png";
import ca_4 from "../../assests/Pages/CallAnalysis/ca_img_4.png";
import f_ca_img1 from "../../assests/Pages/CallAnalysis/feature_ca1.png";
import f_ca_img2 from "../../assests/Pages/CallAnalysis/feature_ca2.png";
import f_ca_img3 from "../../assests/Pages/CallAnalysis/feature_ca3.png";
import f_ca_img4 from "../../assests/Pages/CallAnalysis/feature_ca4.png";
import f_ca_img5 from "../../assests/Pages/CallAnalysis/feature_ca5.png";
import f_ca_img6 from "../../assests/Pages/CallAnalysis/feature_ca6.png";
import CallAnalysisFeatureCommonComponent from '../../Component/CallAnalysisFeatureCommonComponent/CallAnalysisFeatureCommonComponent'
import CallAnalysisOverview from '../../Component/CallAnalysisOverview/CallAnalysisOverview'
import CallAnalysisBenefits from '../../Component/CallAnalysisBenefits/CallAnalysisBenefits'
import ScheduleDemoSection from '../../Component/ScheduleDemoSection/ScheduleDemoSection'
import ParaphraseOverlapFooter from '../../Component/ParaphraserSections/ParaphraseOverlapFooter'
import ca_common_mb_1 from "../../assests/Pages/CallAnalysis/ca_common_mb_1.png";
import ca_common_mb_2 from "../../assests/Pages/CallAnalysis/ca_common_mb_2.png";
import ca_common_mb_3 from "../../assests/Pages/CallAnalysis/ca_common_mb_3.png";
import ca_common_mb_4 from "../../assests/Pages/CallAnalysis/ca_common_mb_4.png";

const CallAnalysisGlobal = (props) => {
    const { flagBanner, setFlagBanner, blogHeader } = props

    const [chatbotFaqs, setChatbotFaqs] = useState([
    {
        question: "What makes this AI agent different from other chatbots?",
        answer: "Our AI agent isn’t just about conversations—it drives engagement with image carousels, quick replies, and actionable CTAs. It personalizes interactions, offers seamless human handoffs when needed, and integrates effortlessly with your existing tools, ensuring a smooth, efficient customer experience.",
    },
    {
        question: "How fast can I set it up on my website?",
        answer: "In just a few minutes! With our no-code, no workflow platform, you simply write what you need, and your chatbot is ready to go live. No complicated workflows or technical expertise required."
    },
    {
        question: "Can I customize the chatbot’s design and behavior?",
        answer: "Absolutely! From tone and personality to the chatbot’s visual design, you have complete control to match your brand perfectly. Embed it anywhere on your site—on product pages, forms, or checkout—so your customers get help where they need it most.",
    },
    {
        question: "Does the AI agent work with my existing systems?",
        answer: "Yes! Our AI agent integrates seamlessly with CRMs, helpdesk software, and other tools, ensuring your data flows smoothly and your team stays in sync."
    },
    {
        question: "What if the AI agent can’t answer a customer’s query?",
        answer:
        "No problem! When the AI reaches its limits, it hands over the conversation to a human agent smoothly—ensuring a seamless experience with zero disruption to the customer."
    },
    {
        question: "How does the chatbot help with engagement and conversions?",
        answer:
        "The AI agent interacts visually and dynamically—using image carousels, quick replies, and CTAs—to guide customers through product discovery, answer questions instantly, and drive meaningful actions like purchases or bookings."
    },
    ])



  const callAnalysisFormatData = [
    {
      ca_formatId: 1,
      ca_sub_field: "Make smarter decisions with AI powered by real conversations",
      ca_details: ["Why guess when your calls can tell you everything? Our platform delivers complete call analysis — from sentiment detection to topic trends."," We automatically transcribe audio to text, summarize, and analyze your calls, turning every interaction into insights. Whether you're improving marketing, boosting team performance, or enhancing customer experience, we give you the clarity to act fast.","You're not just tracking calls — you're unlocking real business value."],
      ca_img:  ca_1,
      ca_img_mb: ca_common_mb_1
    },
    {
      ca_formatId: 2,
      ca_sub_field: "Marketing AI that’s built for voice and ready out of the box",
      ca_details: ["Unlike legacy tools that need training, our voice AI is smart from the start.","It listens, interprets, and tags your calls with precision. From detecting customer intent and sentiment to auto-tagging leads, our AI lightens the manual load and speeds up decision-making.","Set your own tagging rules — our system organizes calls around what matters most. It’s your data, only smarter."],
      ca_img: ca_2,
      ca_img_mb: ca_common_mb_2
    },
    {
      ca_formatId: 3,
      ca_sub_field: "Instant insights, no playback required",
      ca_details: ["Every conversation has value — if you can access it fast.","With automatic transcription and smart call summaries, you get the full story of every interaction in seconds. No need to replay audio or scroll through endless notes — we highlight what matters most. From key moments to tone shifts, our AI helps you understand customer intent, spot patterns, and take action faster.","Your calls aren’t just talk — they’re insight engines."],
      ca_img: ca_3,
      ca_img_mb: ca_common_mb_3
    },
    {
      ca_formatId: 4,
      ca_sub_field: "Know who’s talking and what each person really means",
      ca_details: ["In multi-speaker calls, context is everything. Our platform separates voices accurately, identifying each speaker’s tone, intent, and role.","Sales reps, customers, managers — all analyzed individually for sharper feedback and coaching.","No more confusion over who said what. Every voice, clearly heard and understood."],
      ca_img: ca_4,
      ca_img_mb: ca_common_mb_4
    }
  ];
  
  const callAnalysisFeatureFormatData = [
    {
      format_id: 1,
      featureCallAnalysisData: [
        {
          f_ca_id: 1,
          f_ca_img: f_ca_img1,
          f_ca_heading: 'Audio Call Processing',
          f_ca_detail: 'Effortlessly upload your call recordings for advanced AI analysis. Gain valuable insights through automated transcription, performance evaluation, and sentiment assessment.'
        },
        {
          f_ca_id: 2,
          f_ca_img: f_ca_img2,
          f_ca_heading: 'Accurate Transcription',
          f_ca_detail: 'Convert every call into a precise, word-for-word text transcript with AI-powered accuracy. Easily review, search, and analyze conversations to uncover key insights.'
        },
        {
          f_ca_id: 3,
          f_ca_img: f_ca_img3,
          f_ca_heading: 'Descriptive AI Analysis',
          f_ca_detail: 'Leverage AI-driven summaries and evaluations to extract key insights from every conversation. Identify trends, assess performance, and enhance decision making with intelligent analysis.'
        },
        {
          f_ca_id: 4,
          f_ca_img: f_ca_img4,
          f_ca_heading: 'Evaluation Scores',
          f_ca_detail: 'Receive AI-generated performance ratings tailored to predefined criteria for objective assessments. Track agent effectiveness, ensure compliance, and drive continuous improvement with data-backed insights.'
        },
        {
          f_ca_id: 5,
          f_ca_img: f_ca_img5,
          f_ca_heading: 'Speaker Identification',
          f_ca_detail: 'Accurately differentiates between the agent and the client in every conversation. Gain clearer insights with speaker-labeled transcripts for better analysis and accountability.'
        },
        {
          f_ca_id: 6,
          f_ca_img: f_ca_img6,
          f_ca_heading: 'Tone Analysis',
          f_ca_detail: 'AI detects and categorizes the emotional tone of both the agent and the client. Understand sentiment, improve interactions, and enhance customer experience with in-depth analysis.'
        }
      ]
    }
  ];
  

    return (
        <Grid container sx={{ position: 'relative' }}>
            <Navbar flagBanner={flagBanner} setFlagBanner={setFlagBanner} />
            <Grid item xs={12} mt={{ xs: flagBanner ? 10 : 0, md: flagBanner ? 8 : 0 }} sx={{ overflowX: "hidden" }}>
                <Grid container>
                  <Grid item xs={12} className='brsw-new-head-section-main-item'>
                      <HeroSectionNewDesign />
                  </Grid>

                  <Grid item xs={12} sx={{backgroundColor: "#FAFAFA"}}>
                    <Grid container>
                      {callAnalysisFormatData.map((format, index) =>
                        <Grid item xs={12} key={index}>
                          <CallAnalysisCommonComponent format={format} isLast={index === callAnalysisFormatData.length - 1} />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container>
                      {callAnalysisFeatureFormatData.map((format, index) =>
                        <Grid item xs={12} key={index}>
                          <CallAnalysisFeatureCommonComponent format={format} />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sx={{backgroundColor: "#F8F8F8", position:"relative"}}>
                      <CallAnalysisOverview />
                  </Grid>

                  <Grid item xs={12}>
                      <CallAnalysisBenefits />
                  </Grid>
                
                  <Grid item xs={12} className='chatbot-faq-section'>
                      <ChatbotFAQs faqData={chatbotFaqs} />
                  </Grid>
                
                  <Grid item xs={12}>
                      <ScheduleDemoSection />
                  </Grid>

                  <Grid item xs={12} className='pr-overlap-item'>
                      <ParaphraseOverlapFooter />
                  </Grid>

                  <Grid item xs={12} className='brsw-footer-component-main-item'>
                      <LandingFooter />
                  </Grid>
          
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CallAnalysisGlobal
